export function log_info(name: string, message: string): void {
  console.debug(
    `%c ${name}`,
    "color: white; background-color: #0d47a1",
    message
  );
}
